export const BEHAVIOUR_TYPES = [
  { name: "Aggression", value: "Aggression" },
  { name: "Delusions", value: "Delusions" },
  { name: "Hallucinations", value: "Hallucinations" },
  { name: "Increased agitation", value: "Increased agitation" },
  { name: "Physical abuse", value: "Physical abuse" },
  { name: "Self-injurious behaviour", value: "Self-injurious behaviour" },
  { name: "Sexualised behaviour", value: "Sexualised behaviour" },
  { name: "Shouting or screaming", value: "Shouting or screaming" },
  { name: "Soiling/smearing", value: "Soiling/smearing" },
  { name: "Swearing", value: "Swearing" },
  {
    name: "Throwing items/braking things",
    value: "Throwing items/braking things",
  },
  { name: "Verbal abuse", value: "Verbal abuse" },
];

export const SERVICE_USER_PRESENTATION = [
  { name: "Worried", value: "Worried" },
  { name: "Angry", value: "Angry" },
  { name: "Anxious", value: "Anxious" },
  { name: "Frightened", value: "Frightened" },
];

export const RISK_LEVELS = [
  { value: "LOW", color: "success" },
  { value: "MEDIUM", color: "warning" },
  { value: "HIGH", color: "info" },
  { value: "CRITICAL", color: "error" },
];
